/*
 * Product gallery read-ahead (PageSpeed 2026-10-13).
 *
 * Slides 3+ of the product gallery carry loading="lazy" (the sis hunk in
 * snippets/product-media-gallery-content.liquid), so a page view downloads two
 * slides instead of all ~25. Chrome does not start a lazy slide until it is
 * actually scrolled into view, which would show a blank slide for a moment on a
 * slow phone. So, from the customer's first touch on the gallery and on every
 * gallery scroll (swipe, arrows, thumbnails, dots), the current slide and the two
 * after it are switched to eager, which starts their download at once.
 */
(() => {
  const AHEAD = 2;
  const SCROLLER = 'media-gallery slideshow-slides';

  const readAhead = (scroller) => {
    const slides = scroller.children;
    if (!slides.length) return;
    // nearest slide by offset, not scrollLeft / width: the gallery's image gap would drift the count
    const left = Math.abs(scroller.scrollLeft);
    let current = 0;
    for (let i = 1; i < slides.length; i++) {
      if (Math.abs(slides[i].offsetLeft - left) < Math.abs(slides[current].offsetLeft - left)) current = i;
    }
    const last = Math.min(slides.length - 1, current + AHEAD);
    for (let i = current; i <= last; i++) {
      for (const img of slides[i].querySelectorAll('img[loading="lazy"]')) img.loading = 'eager';
    }
  };

  document.addEventListener(
    'pointerdown',
    (event) => {
      const scroller = event.target instanceof Element && event.target.closest('media-gallery')?.querySelector(SCROLLER);
      if (scroller) readAhead(scroller);
    },
    { capture: true, passive: true }
  );
  // scroll does not bubble; a capturing document listener still sees every element's scroll
  document.addEventListener(
    'scroll',
    (event) => {
      if (event.target instanceof Element && event.target.matches(SCROLLER)) readAhead(event.target);
    },
    { capture: true, passive: true }
  );
})();
